/* eslint-disable no-var */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext, useEffect, useReducer, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Box, CssBaseline } from '@material-ui/core';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AppDrawer } from '../../components';
import { mainmenu } from '../../constants';
import {
  EventsContext,
  GlobalContext,
  CalendarContext,
  FinanceContext,
  initFinanceContext,
  financeReducer,
} from '../../contexts';
import { layoutClasses } from '../../themes';
import Options from '../options';

import { GContextTypes } from '../../types';

import { useBranches, useTemplate, useUsers } from '../../hooks';
import PageLayout from './PageLayout';
import { initCalendar, calendarReducer } from '../../contexts';

import { filterMenu } from '../../common/helpers';
import Branches from '../adds/Branches';
import React from 'react';
import AlertWithClose from '../../components/fields/AlertWithClose';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import useCompany from '../../hooks/useCompany';
import Groups from '../adds/Groups';
import Sendreqs from '../adds/Sendreqs';
import Messages from '../adds/Messages';
import MSGTemplates from '../adds/MSGTemplates';
import Notifications from '../adds/Notifications';

import { useLazyQuery, useSubscription } from '@apollo/client';
import {
  eventChange,
  eventStopChange,
  notifiAdded,
} from '../../graphql/subscription';
import LetterOperations from '../../Sections/Letters/LetterOperations';
import OperationOperations from '../../Sections/Operations/OperationOperations';
import {
  addsList,
  expensesList,
  financeList,
  hrList,
  operationsList,
  orderList,
  purchaseList,
  reminderList,
  reportsList,
  salesList,
} from '../../constants/menu';
import SalesOperations from '../../Sections/Sales/SalesOperations';
import PurchaseOperations from '../../Sections/Purchase/PurchaseOperations';
import ExpensesOperations from '../../Sections/Expenses/ExpensesOperations';
import FinanceOperations from '../../Sections/Finance/FinanceOperations';
import BasicsAdd from '../../Sections/Basics/BasicsAdd';
import ReminderOperations from '../../Sections/Reminder/ReminderOperations';
import CalendarOperations from '../../Sections/Calendar/CalendarOperations';
import LandingOperations from '../../Sections/Landing/LandingOperations';
import ReportsList from '../../Sections/reports/ReportsList';
import getMyInbox from '../../graphql/query/getMyInbox';
import CalendarEmp from '../calendar/CalendarEmp';
import OrderOperations from '../../Sections/Order/OrderOperations';
import IconsLanding from './IconsLanding';
import DocumentPopup from '../../document/DocumentPopup';
import { getStoreItem, setStoreItem } from '../../store';
import { hrReducer, initHRContext } from '../../contexts/hr/salesReducer';
import HRContext from '../../contexts/hr';
import HROperations from '../../Sections/HR/HROperations';
import ApprovalManagement from '../../Sections/shared/ApprovalManagement';
import UrgentRequests from '../../Sections/Archive/UrgentRequests';

const Content = ({ formdocs }: any) => {
  const classes = layoutClasses();
  const [mmenu, setMmenu] = useState(null);
  const [menuitem, setMenuitem] = useState(mainmenu[0]);
  const [evenetOpened, setEvenetOpened] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(80);
  const [open, setOpen] = React.useState(false);
  const [newin, setNewin] = useState(0);

  const theme = useTheme();
  const location = useLocation();
  const pathname = location?.pathname;
  const { tempoptions } = useTemplate();
  const { allusers } = useUsers();
  const fusers = allusers
    .map((usr: any) => {
      const name = usr?.name ? usr?.name : usr?.username;
      if (usr?.isSuperAdmin) return undefined;
      return {
        ...usr,
        name,
        nameAr: name,
      };
    })
    ?.filter((x: any) => x);

  useEffect(() => {
    if (pathname && pathname.length > 0) {
      if (pathname === '/') {
        setMenuitem(mainmenu[0]);
      } else {
        const pname = pathname?.split('/')?.[1];
        const mitem = mainmenu?.filter(
          (mi: any) => mi.uri === `/${pname}`,
        )?.[0];
        if (mitem && mitem !== menuitem) {
          setMenuitem(mitem);
        }
      }
    }
  }, [pathname]);

  const letterforms = formdocs
    ?.filter((fd: any) => fd?.gref === 'letter')
    ?.map((it: any) => {
      return {
        ...it,
        path: it?.autoNoType,
      };
    });

  const { company, editCompany, refreshcompany } = useCompany();
  const { branches } = useBranches();
  const {
    store: {
      user,
      calendar,
      network,
      packIssue,
      packIssueMsg,
      notify,
      tempId,
      scrollbar,
    },
    dispatch,
    translate: { words, isRTL },
  }: GContextTypes = useContext(GlobalContext);
  const { isMobile } = useWindowDimensions();

  const logout = () => {
    dispatch({ type: 'logout' });
  };

  const [calendarStore, calendarDispatch] = useReducer(
    calendarReducer,
    initCalendar,
  );
  const [financeStore, financeDispatch] = useReducer(
    financeReducer,
    initFinanceContext,
  );

  const sub = useSubscription(
    evenetOpened || !tempoptions?.livedata ? eventStopChange : eventChange,
    {
      fetchPolicy: 'network-only',
      shouldResubscribe: true,
    },
  );
  const notifisub = useSubscription(notifiAdded, {
    fetchPolicy: 'network-only',
    shouldResubscribe: true,
  });

  // HR
  const hrStoreState = getStoreItem('hrStore', initHRContext);
  const [hrStore, hrDispatch] = useReducer(
    hrReducer,
    hrStoreState ? hrStoreState : initHRContext,
  );
  useEffect(() => {
    setStoreItem('hrStore', hrStore);
  }, [hrStore]);
  // Load inbox budge
  const [loadInbox, inboxData]: any = useLazyQuery(getMyInbox);
  useEffect(() => {
    const d = inboxData?.data?.getMyInbox?.data;
    if (d) {
      const newin = d.filter((i: any) => !i.read)?.length;
      setNewin(newin);
    }
  }, [inboxData]);

  useEffect(() => {
    loadInbox({ skip: 0 });
  }, []);
  const isPOS = pathname === '/pos';
  return (
    <Box
      className={classes.root}
      dir={isRTL ? 'rtl' : undefined}
      display="flex"
      style={{
        flex: 1,
      }}
    >
      <CssBaseline />
      {!isPOS && (
        <AppDrawer
          isRTL={isRTL}
          setMenuitem={setMenuitem}
          menuitem={menuitem}
          user={user}
          branches={branches}
          menu={filterMenu(isMobile)}
          logout={logout}
          network={network}
          setMmenu={setMmenu}
          mmenu={mmenu}
          notify={notify}
          company={company}
          scrollbar={scrollbar}
          drawerWidth={drawerWidth}
          setDrawerWidth={setDrawerWidth}
          open={open}
          setOpen={setOpen}
          newin={newin}
        ></AppDrawer>
      )}
      <main
        style={{ marginTop: isMobile ? 50 : undefined }}
        className={classes.content}
      >
        <Routes>
          <Route
            path="/"
            element={
              <IconsLanding
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                user={user}
                theme={theme}
                company={company}
                dispatch={dispatch}
              ></IconsLanding>
            }
          />
          <Route
            path="/main"
            element={
              <LandingOperations
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                user={user}
                theme={theme}
                company={company}
                dispatch={dispatch}
                notifisub={notifisub}
              ></LandingOperations>
            }
          />
          <Route
            path={'/letters/*'}
            element={
              <LetterOperations
                menuitem={menuitem}
                formgroup={letterforms}
                isRTL={isRTL}
                words={words}
                theme={theme}
                user={user}
                drawerWidth={drawerWidth}
                users={fusers}
                company={company}
              ></LetterOperations>
            }
          />
          <Route
            path={'/order/*'}
            element={
              <OrderOperations
                menuitem={menuitem}
                formgroup={orderList}
                isRTL={isRTL}
                words={words}
                theme={theme}
                user={user}
                drawerWidth={drawerWidth}
                users={fusers}
                company={company}
              ></OrderOperations>
            }
          />
          <Route
            path={'/operations/*'}
            element={
              <OperationOperations
                menuitem={menuitem}
                formgroup={operationsList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></OperationOperations>
            }
          />
          <Route
            path={'/sales/*'}
            element={
              <SalesOperations
                menuitem={menuitem}
                formgroup={salesList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></SalesOperations>
            }
          />
          <Route
            path={'/hr/*'}
            element={
              <HRContext.Provider
                value={{ state: hrStore, dispatch: hrDispatch }}
              >
                <HROperations
                  menuitem={menuitem}
                  formgroup={hrList?.filter((item: any) => !item.hide)}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                  drawerWidth={drawerWidth}
                ></HROperations>
              </HRContext.Provider>
            }
          />
          <Route
            path="/approvals"
            element={
              <PageLayout
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
              >
                <ApprovalManagement
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                ></ApprovalManagement>
              </PageLayout>
            }
          />
          <Route
            path="/urgent"
            element={
              <UrgentRequests
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
              ></UrgentRequests>
            }
          />
          <Route
            path={'/purchase/*'}
            element={
              <PurchaseOperations
                menuitem={menuitem}
                formgroup={purchaseList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></PurchaseOperations>
            }
          />
          <Route
            path={'/expenses/*'}
            element={
              <ExpensesOperations
                menuitem={menuitem}
                formgroup={expensesList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></ExpensesOperations>
            }
          />
          <Route
            path={'/finance/*'}
            element={
              <FinanceContext.Provider
                value={{ state: financeStore, dispatch: financeDispatch }}
              >
                <FinanceOperations
                  menuitem={menuitem}
                  formgroup={financeList?.filter((item: any) => !item.hide)}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                  drawerWidth={drawerWidth}
                ></FinanceOperations>
              </FinanceContext.Provider>
            }
          />
          <Route
            path={'/basicadd/*'}
            element={
              <BasicsAdd
                menuitem={menuitem}
                formgroup={addsList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></BasicsAdd>
            }
          />
          <Route
            path={'/reports/*'}
            element={
              <ReportsList
                menuitem={menuitem}
                formgroup={reportsList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
                drawerWidth={drawerWidth}
              ></ReportsList>
            }
          />
          <Route
            path="/reminder/*"
            element={
              <ReminderOperations
                menuitem={menuitem}
                formgroup={reminderList?.filter((item: any) => !item.hide)}
                isRTL={isRTL}
                words={words}
                theme={theme}
              ></ReminderOperations>
            }
          />
          <Route
            path="/calendar"
            element={
              <CalendarOperations
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                calendar={calendar}
                dispatch={dispatch}
                company={company}
                tempId={tempId}
                user={user}
                evenetOpened={evenetOpened}
                setEvenetOpened={setEvenetOpened}
                sub={sub}
                drawerWidth={drawerWidth}
              ></CalendarOperations>
            }
          />
          <Route
            path="/mobcalendar"
            element={
              <CalendarContext.Provider
                value={{ state: calendarStore, dispatch: calendarDispatch }}
              >
                <CalendarEmp
                  menuitem={menuitem}
                  isMobile={isMobile}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                  calendar={calendar}
                  gDispatch={dispatch}
                  company={company}
                  tempId={tempId}
                  user={user}
                  evenetOpened={evenetOpened}
                  setEvenetOpened={setEvenetOpened}
                  sub={sub}
                  drawerWidth={drawerWidth}
                ></CalendarEmp>
              </CalendarContext.Provider>
            }
          />

          <Route
            path="/groups"
            element={
              <Groups
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
              ></Groups>
            }
          />
          <Route
            path="/msgtemplates"
            element={
              <MSGTemplates
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
              ></MSGTemplates>
            }
          />

          <Route
            path="/messages"
            element={
              <EventsContext.Provider
                value={{ state: calendarStore, dispatch: calendarDispatch }}
              >
                <Messages
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                  menuitem={menuitem}
                  company={company}
                  refreshcompany={refreshcompany}
                ></Messages>
              </EventsContext.Provider>
            }
          />
          <Route
            path="/notifications"
            element={
              <Notifications
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
                notify={notify}
                dispatch={dispatch}
                company={company}
                user={user}
              ></Notifications>
            }
          />
          <Route
            path="/sendreqs"
            element={
              <Sendreqs
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
                company={company}
              ></Sendreqs>
            }
          />
          {user.isSuperAdmin && (
            <Route
              path="/branches"
              element={
                <PageLayout
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                >
                  <Branches
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                  ></Branches>
                </PageLayout>
              }
            />
          )}
          <Route
            path="/options"
            element={
              <PageLayout
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                refresh={refreshcompany}
                editCompany={editCompany}
                company={company}
              >
                <Options></Options>
              </PageLayout>
            }
          />
        </Routes>
        <AlertWithClose
          open={packIssue}
          dispatch={dispatch}
          isRTL={isRTL}
          msg={packIssueMsg}
          onClose={() => dispatch({ type: 'closePackIssue' })}
        ></AlertWithClose>
        <DocumentPopup words={words} isRTL={isRTL}></DocumentPopup>
      </main>
    </Box>
  );
};
export default Content;
